import { ConfigProvider, Tabs } from "antd";
import PropTypes from "prop-types";

function CarDetailSubTabs({ tabs, active, onChange, children }) {
    const items = tabs.map((tab) => ({
        key: String(tab.id),
        label: tab.label,
    }));

    return (
        <ConfigProvider
            theme={{
                components: {
                    Tabs: {
                        inkBarColor: "#5d5dff",
                        itemSelectedColor: "#5d5dff",
                        itemHoverColor: "#5d5dff",
                    },
                },
            }}>
            <Tabs
                activeKey={String(active)}
                onChange={(key) => onChange(Number(key))}
                items={items}
                size="small"
                className="car-detail-subtabs mb-3 px-2"
            />
            {children}
        </ConfigProvider>
    );
}

CarDetailSubTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    active: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default CarDetailSubTabs;
